import { Injectable } from '@angular/core';
import { UserApiProvider } from '../new-http/providers/user-api.service';

@Injectable({
    providedIn: 'root',
})
export class UserTagService {
    constructor(private userApi: UserApiProvider) {}

    public get(url: string, ) {
        return this.userApi.get(url);
    }
}